module.exports = __webpack_public_path__ + "static/media/ZoneB.92c967c2.png";